import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import Box from '@material-ui/core/Box';
import { BastionContext } from 'context';
import useStyles from './authLayout.styled';
import { Typography } from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';
import packageInfo from '../../../../package.json';
import i18n from 'i18n-js';

const AuthLayout = ({ children, title, fullBackground = false }) => {
  const classes = useStyles();

  const { theme } = useContext(BastionContext);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{title}</title>
        <link rel="icon" sizes="16x16" type="image/png" href={theme.page.favicon} />
      </Helmet>
      <Box data-cy="auth-layout" className={classes.container}>
        {!fullBackground && (
          <Box data-cy="auth-card-container" className={classes.authCardContainer}>
            <Box className={classes.root}>
              {children}
              <Typography data-cy="auth-card-container-footer" color="textSecondary" align="center">
                <Box fontSize={14} mb={5} component="span">
                  © {new Date().getFullYear()} Launch Mobility, Inc. | Version:{' '}
                  {packageInfo.version}
                </Box>
              </Typography>
            </Box>
          </Box>
        )}
        <Box
          data-cy="auth-background-container"
          className={[
            classes.authBackgroundContainer,
            fullBackground ? classes.fullBackground : null,
          ].join(' ')}
          position="relative"
        >
          <img
            data-cy="auth-background-img"
            alt="background"
            src={theme.background.src}
            className={classes.authBackground}
          />
          <Box data-cy="auth-background-img-color" className={classes.imgBg} />
          <Box data-cy="auth-support" className={classes.supportContainer}>
            <a href="mailto:operations@launchmobility.com" className={classes.support}>
              <HelpIcon style={{ color: '#FFF', fontSize: 20 }} />
              <Typography className={classes.logoDescription}>
                <Box fontSize={16} component="span" ml={1} display="block">
                  Support
                </Box>
              </Typography>
            </a>
          </Box>
          <Box
            data-cy="auth-logo"
            className={[
              classes.logoContainer,
              fullBackground ? classes.logoContainerFullBg : null,
            ].join(' ')}
          >
            <img alt="logo" src={theme.logo.src} />
          </Box>
          {fullBackground && (
            <>
              {children}
              <Box data-cy="auth-footer" className={classes.footer}>
                <Typography color="textSecondary" align="center">
                  <Box fontSize={14} mb={5} component="span">
                    © {new Date().getFullYear()}{' '}
                    <Typography
                      component="span"
                      display="inline"
                      className={classes.launchMobilityFont}
                    >
                      {i18n.t('common.lm_name')}
                    </Typography>
                    {` ${i18n.t('common.all_rights_reserved')}`}
                  </Box>
                </Typography>
              </Box>
            </>
          )}
        </Box>
      </Box>
    </>
  );
};

// Define prop types for the component
AuthLayout.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  fullBackground: PropTypes.bool,
};

export default AuthLayout;
